module.exports = __webpack_public_path__ + "img/giftcard_desktop_failed.55700d32.svg";